module.exports = "<my-owner-display my-owner=\"$$owner.data.myOwner\"\n  my-contacts=\"$$contact.data.myContacts\"\n  enable-buttons=\"true\"\n  enable-links=\"true\"\n  enable-back=\"true\">\n</my-owner-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/owner/templates/details.html
// module id = 1510
// module chunks = 0